import * as React from 'react';
import { useSelector } from 'react-redux';

import { HeroBanner } from '../../../../components/MyHome/HeroBanner';
import { Section } from '../../../../components/Section';
import { EScrollingBlocks } from '../../../../constants/scrollingBlocks';
import { selectIsWebview } from '../../../../selectors/page';
import { MobileInfrastructureContainerLoad } from '../../../InfrastructureMapContainer';
import { MarketPriceContainer } from '../../../MarketPriceContainer';
import { MyHomeListingContainer } from '../../../MyHomeListingContainer';
import { ObjectInfoContainer } from '../../../ObjectInfoContainer';
import { OffersHistoryContainer } from '../../../OfferHistory/Mobile';
import { RateOurEstimationContainer } from '../../../RateOurEstimationContainer';
import { useScrollingRef } from '../../../Scrolling';
import { ValuationContentContainer } from '../../../ValuationContentContainer';
import { BannerWrapper } from '../../../../components/BannerWrapper';
import { ServicesContainer } from '../../../ServicesContainer';
import { StatusList } from '../../../Status/containers/StatusList';
import { PrelandingContainer } from '../../../PrelandingContainer';
import { SubscribeWidgetContainer } from '../../../SubscribeWidget';

export const MyHomeMobileView: React.FC = () => {
  const isWebview = useSelector(selectIsWebview);
  const marketPriceRef = useScrollingRef(EScrollingBlocks.MarketPrice);
  const offersHistoryRef = useScrollingRef(EScrollingBlocks.OffersHistory);
  const infrastructureRef = useScrollingRef(EScrollingBlocks.Infrastructure);
  const objectInfoRef = useScrollingRef(EScrollingBlocks.ObjectInfo);

  return (
    <>
      {!isWebview && (
        <HeroBanner>
          <MyHomeListingContainer />
        </HeroBanner>
      )}
      <ValuationContentContainer>
        <Section marginTop={32}>
          <ObjectInfoContainer refWrapper={objectInfoRef} />
        </Section>
        <Section>
          <BannerWrapper />
        </Section>
        <Section marginBottom={48}>
          <MarketPriceContainer refWrapper={marketPriceRef} />
          <ServicesContainer />
          <RateOurEstimationContainer />
        </Section>
        <Section marginBottom={48}>
          <OffersHistoryContainer refWrapper={offersHistoryRef} />
        </Section>
        <Section marginBottom={48}>
          <MobileInfrastructureContainerLoad refWrapper={infrastructureRef} />
        </Section>
      </ValuationContentContainer>
      <PrelandingContainer />
      <StatusList />

      <SubscribeWidgetContainer />
    </>
  );
};

MyHomeMobileView.displayName = 'MobileView';
